<mat-expansion-panel
  class="mat-elevation-z0"
  hideToggle="true"
  (opened)="emitOpened()"
  (closed)="emitClosed()"
  [expanded]="panelOpen"
>
  <mat-expansion-panel-header *ngIf="!panelOpen">
    <mat-panel-title>
      {{ panelHeader }}
    </mat-panel-title>
    <mat-panel-description *ngIf="panelTitle; else emptyTitle">
      {{ panelTitle }}
    </mat-panel-description>
    <ng-template #emptyTitle>
      <mat-panel-description class="empty-field">
      {{ "summary.emptyField" | translate }}
    </mat-panel-description>
    </ng-template>
    <div class="icon icon-edit"></div>
  </mat-expansion-panel-header>

  <div class="content-container">
    <ng-content select="[content]"></ng-content>
  </div>

  <div class="actions" *ngIf="!simple">
    <button mat-flat-button color="primary" (click)="emitClosed()">
      {{ "summary.buttonText.done" | translate }}
    </button>
  </div>
</mat-expansion-panel>
